import frustumCull from '../frustumCull'

export default `
  uniform vec2 uResolution;
  uniform vec2 uFboSize;
  uniform sampler2D tGlass;
  uniform vec3 uColor2;
  uniform vec3 uBgColor;
  uniform vec4 uRectData;
  uniform vec4 uRectData2;
  uniform vec4 uProgress;
  uniform vec3 uLightPos;

  varying vec3 vPosition;
  varying vec3 vNormal;
  varying vec3 vNormal2;

  void main(){
    vec2 uv;
    uv.x = (gl_FragCoord.x - uRectData.z) / uRectData.x;
    uv.y = (gl_FragCoord.y - (uRectData.w - uRectData.y)) / uRectData.y;

    // Optional: clamp to [0,1] range
    uv = clamp(uv, 0.0, 1.0);

    vec4 color = vec4(0.0);
    // Apply distortion based on normal
    // similar to matcap uv calculation with only vNormal2
    vec2 distort = -normalize(vNormal2.xy) * 0.02;
    uv += distort;

    float light = dot(normalize(vNormal2), uLightPos) * 0.5 + 0.5;
    light = smoothstep(0.8, 1.0, light);

    color = texture2D(tGlass, uv);

    #ifdef WHITE_GLASS
      color.rgb = mix(vec3(1.0) + color.rgb, color.rgb, color.a);
      color.rgb = mix(color.rgb, vec3(1.0), 0.5);
    #else
      color.rgb = mix(uBgColor + color.rgb, color.rgb, color.a);
      color.rgb = mix(color.rgb, vec3(1.0), 0.1);
    #endif


    color.rgb = mix(color.rgb, uColor2, 0.2 * light);
    color.a = 1.0;

    ${frustumCull}
    gl_FragColor = color;

    gl_FragColor.rgb = mix(uBgColor, gl_FragColor.rgb, uProgress.x);
    // gl_FragColor = vec4(vNormal2, 1.0);
  }
`
